export const menuSite = [
  {
    name: 'Portfolio',
    href: '#portfolio',
  },
  {
    name: 'About Me',
    href: '#about',
  },
  {
    name: 'Skills',
    href: '#skill',
  },
  {
    name: 'How I Can Help',
    href: '#services-offered',
  },
  {
    name: 'Contacts',
    href: '#contact',
  },
]

export const menuSocialMidas = [
  {
    name: 'Linkedin',
    icon: 'linkedin',
    href: 'https://www.linkedin.com/in/tatielirb/',
  },
  {
    name: 'Behance',
    icon: 'behance',
    href: 'https://www.behance.net/tatielirb',
  },
  {
    name: 'Github',
    icon: 'github',
    href: 'https://github.com/tatielirb',
  },
  {
    name: 'Medium',
    icon: 'medium',
    href: 'https://medium.com/@tatielirb',
  },
]
